import { ca } from '@cian/analytics';

export const trackApplyChatbotFilters = (jsonQuery: object) => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'ChatBot',
    action: 'Click_sopr',
    label: 'Filter',
    page: {
      extra: {
        chat_id: 'chatbot',
      },
    },
    sc: jsonQuery,
  });
};
